import { ClubTeamHighlight } from "@/models";
import restApiDispatcher from "@/store/utils/api-dispatcher";

const getClubTeamHighlight = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlight",
    loadingKey: "clubTeamHighlightLoading",
    action: "showWithProfileId",
    commitType: "show",
    params
  });

const getClubTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlights",
    loadingKey: "clubTeamHighlightsLoading",
    action: "index",
    commitType: "indexUnwrapped",
    params
  });

const getClubTeamHighlightsLimited = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlightsLimited",
    loadingKey: "clubTeamHighlightsLoading",
    action: "indexLimited",
    commitType: "indexUnwrapped",
    params
  });

const createClubTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlight",
    loadingKey: "clubTeamHighlightLoading",
    action: "create",
    commitType: "show",
    params
  });

const updateClubTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlight",
    loadingKey: "clubTeamHighlightLoading",
    action: "update",
    commitType: "update",
    params
  });

const deleteClubTeamHighlights = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlight",
    loadingKey: "clubTeamHighlightsLoading",
    action: "delete",
    commitType: "show",
    message: "Highlight deleted successfully.",
    params
  });

const updateImageForHighlight = (context, params) =>
  restApiDispatcher(context, {
    resource: ClubTeamHighlight,
    storeKey: "clubTeamHighlight",
    loadingKey: "clubTeamHighlightLoading",
    action: "imageUpdate",
    commitType: "show",
    params
  });

const afterDeleteActions = (context, params) =>
  context.commit("AFTER_DELETE_ACTIONS", params.id);

export default {
  getClubTeamHighlight,
  getClubTeamHighlights,
  createClubTeamHighlights,
  updateClubTeamHighlights,
  deleteClubTeamHighlights,
  afterDeleteActions,
  updateImageForHighlight,
  getClubTeamHighlightsLimited
};
